import Vue from "vue";
import Router from "vue-router";

// Authentication Pages
const AuthPage = () => import("@/views/Auth/AuthPage");
const Login = () => import("@/views/Auth/Login");
const Register = () => import("@/views/Auth/Register");
const Forgot = () => import("@/views/Auth/Forgot");
const Logout = () => import("@/views/Auth/Logout");

// Dashboard
const DashboardPage = () => import("@/views/Dashboard/Index");
const DashboardDefaultPage = () => import("@/views/Dashboard/Default");
const Help = () => import("@/views/Help");

// Response message
const ResponseMessage = () => import("@/components/ResponseMessage");

// wallet
const WalletIndex = () => import("@/views/Wallet/Index");

// Wallet Transactions
const Transactions = () => import("@/views/Wallet/Transactions");
const PrimaryTransactions = () => import("@/views/Wallet/PrimaryTransactions");
const AgentTransactions = () => import("@/views/Wallet/AgentTransactions");
const SettlementTransactions = () => import("@/views/Wallet/SettlementTransactions");
const DemandTransactions = () => import("@/views/Wallet/DemandTransactions");
const SalesTransactions = () => import("@/views/Wallet/SalesTransactions");

//Payment
const PaymentIndex = () => import("@/views/Payment/Index");
const PaymentTopup = () => import("@/views/Payment/Topup");
const PaymentTransactions = () => import("@/views/Payment/Transactions");
const BankAccounts = () => import("@/views/Payment/BankAccounts");
const IndividualTransaction = () => import("@/views/Invoice");

// Stamp
const StampIndex = () => import("@/views/Stamp/Index");
const StampStore = () => import("@/views/Stamp/Store/Index");
const StampBuy = () => import("@/views/Stamp/Store/Buy");
const StampVault = () => import("@/views/Stamp/Vault/Index");
// Use Stamp
const UseStamp = () => import("@/views/Stamp/Use/Index");
// Apply Stamp
const ApplyStamp = () => import("@/views/Stamp/Use/Apply");
// Stamp Log
const StampLog = () => import('@/views/Stamp/Log');
// Stamp History
const StampHistory = () => import("@/views/Stamp/History");
// Stamp Validate
const StampValidateIndex = () => import("@/views/Stamp/Validate/Index");
const StampValidateDefault = () => import("@/views/Stamp/Validate/Default");
// Stamp Issuer
const StampIssuer = () => import("@/views/Stamp/Issued");
// Stamp Transfer
const TransferStamp = () => import("@/views/Stamp/Transfer");
const StampInvoice = () => import("@/views/StampInvoice");

// Verification
const VerificationIndex = () => import("@/views/Verification/Index");
const VerificationAcknowledge = () => import("@/views/Verification/Acknowledge");
const VerificationLog = () => import("@/views/Verification/Log");

// Storage
const StorageIndex = () => import("@/views/Storage/Index");
const StorageTable = () => import("@/views/Storage/Tables");
// Storage Records
const StorageRecordsIndex = () => import("@/views/Storage/Records/Index");
const StorageRecordsDefault = () => import("@/views/Storage/Records/Default");
const StorageRecordsAdd = () => import("@/views/Storage/Records/Add");
// Storage Records Fields
const StorageRecordsAddFields = () => import("@/views/Storage/Records/AddFields");

// Bulk
const BulkIndex = () => import("@/views/Bulk/Index");
const BulkStart = () => import("@/views/Bulk/Start");
const BulkView = () => import("@/views/Bulk/View");
const ViewBulkStamps = () => import("@/views/Bulk/ViewBulkStamps");

// Accounts
const AccountsIndex = () => import("@/views/Accounts/Index");
const ManageAccounts = () => import("@/views/Accounts/Manage");
const UserProfile = () => import("@/views/Accounts/Profile");
const ProfileUpgrade = () => import("@/views/Accounts/Upgrade");

// Organization
const OrganizationIndex = () =>
  import("@/views/Organization/Index");
const OrgProfile = () =>
  import("@/views/Organization/Profile");
const OrgStamps = () =>
  import("@/views/Organization/Stamps");
const OrgTransactions = () =>
  import("@/views/Organization/Transactions");
const OrgNew = () =>
  import("@/views/Organization/Org");

//Integration
const IntegrationIndex = () => import("@/views/Integration/Index");
const Switch = () => import("@/views/Integration/Switch");
const Web = () => import("@/views/Integration/Web");
const ApiCallbacks = () => import("@/views/Integration/ApiCallbacks");

// Document handlers
const DocumentUpload = () => import("@/views/Documents/Upload");
const DocumentFetch = () => import("@/views/Documents/Fetch");


const PageNotFound = () => import("@/views/PageNotFound");
const Empty = () => import("@/components/Empty");
const NotAvailable = () => import("@/components/NotAvailable");
const StampView = () => import("@/components/Stamp/View");

Vue.use(Router);

// global components

Vue.component("response-message", ResponseMessage);
Vue.component("Empty", Empty);
Vue.component("non-refresh", NotAvailable);
Vue.component("StampView", StampView);


export default new Router({
  mode: "history",
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  },
  routes: [
    { 
      path: '/',
      redirect: { name: 'Login' }
    },
    {
      path: "/auth",
      name: "AuthPage",
      component: AuthPage,
      children: [
        {
          path: "login",
          name: "Login",
          component: Login
        },
        {
          path: "register",
          name: "Register",
          component: Register
        },
        {
          path: "forgot",
          name: "Forgot",
          component: Forgot
        },
        {
          path: "logout",
          name: "Logout",
          component: Logout
        }
      ]
    },
    {
      path: "/organization/new",
      name: "NewOrg",
      component: OrgNew
    },
    {
      path: "/dashboard",
      component: DashboardPage,
      children: [
        {
          path: "/",
          name: "DashboardDefaultPage",
          component: DashboardDefaultPage
        },
        {
          path: "wallet",
          name: "WalletIndex",
          component: WalletIndex,
          children: [
            {
              path: "transactions",
              name: "Transactions",
              component: Transactions
            },
            {
              path: "primary-transactions",
              name: "PrimaryTransactions",
              component: PrimaryTransactions
            },
            {
              path: "agent-transactions",
              name: "AgentTransactions",
              component: AgentTransactions
            },
            {
              path: "settlement-transactions",
              name: "SettlementTransactions",
              component: SettlementTransactions
            },
            {
              path: "demand-transactions",
              name: "DemandTransactions",
              component: DemandTransactions
            },
            {
              path: "sales-transactions",
              name: "SalesTransactions",
              component: SalesTransactions
            }
          ]
        },
        {
          path: "payment",
          component: PaymentIndex,
          children: [
            {
              path: "transactions",
              name: "PaymentTransactions",
              component: PaymentTransactions
            },
            {
              path: "bank-account",
              name: "BankAccounts",
              component: BankAccounts
            },
            {
              path: "topup",
              name: "PaymentTopup",
              component: PaymentTopup
            },
            {
              path: "transaction/invoice/:tlid",
              name: "IndividualTransaction",
              component: IndividualTransaction,
              props: true
            }
          ]
        },
        {
          path: "stamp",
          name: "StampIndex",
          component: StampIndex,
          children: [
            {
              path: "store",
              name: "StampStore",
              component: StampStore
            },
            {
              path: "use",
              name: "UseStamp",
              component: UseStamp
            },
            {
              path: "buy/:dlid/:index_",
              name: "StampBuy",
              component: StampBuy
            },
            {
              path: "vault",
              name: "StampVault",
              component: StampVault
            },
            {
              path: "apply",
              name: "ApplyStamp",
              component: ApplyStamp
            },
            {
              path: "log",
              name: "StampLog",
              component: StampLog
            },
            {
              path: "history",
              name: "StampHistory",
              component: StampHistory
            },
            {
              path: "issued",
              name: "StampIssuer",
              component: StampIssuer
            },
            {
              path: "history/invoice/:refInv/:qty/:name",
              name: "StampInvoice",
              component: StampInvoice,
              props: true
            },
            {
              path: "verify",
              component: StampValidateIndex,
              children: [
                {
                  path: "/",
                  name: "StampValidateDefault",
                  component: StampValidateDefault
                }
              ]
            },
            {
              path: "transfer",
              name: "TransferStamp",
              component: TransferStamp
            }
          ]
        },
        {
          path: "storage",
          name: "StorageIndex",
          component: StorageIndex,
          children: [
            {
              path: "tables",
              name: "StorageTable",
              component: StorageTable
            },
            {
              path: "records",
              component: StorageRecordsIndex,
              children: [
                {
                  path: "/",
                  name: "StorageRecordsDefault",
                  component: StorageRecordsDefault
                },
                {
                  path: "add",
                  name: "StorageRecordsAdd",
                  component: StorageRecordsAdd
                },
                {
                  path: "fields",
                  name: "StorageRecordsAddField",
                  component: StorageRecordsAddFields
                }
              ]
            },
            {
              path: "document/upload",
              name: "DocumentUpload",
              component: DocumentUpload
            },
            {
              path: "document/fetch",
              name: "DocumentFetch",
              component: DocumentFetch
            }
          ]
        },
        {
          path: "bulk",
          name: "BulkIndex",
          component: BulkIndex,
          children: [
            {
              path: "start",
              name: "BulkStart",
              component: BulkStart
            },
            {
              path: "view",
              name: "BulkView",
              component: BulkView
            },
            {
              path: "view/:blid",
              name: "ViewBulkStamps",
              component: ViewBulkStamps,
              props: true
            }
          ]
        },
        {
          path: "accounts",
          name: "AccountsIndex",
          component: AccountsIndex,
          children: [
            {
              path: "profile",
              name: "UserProfile",
              component: UserProfile
            },
            {
              path: "manage",
              name: "ManageAccounts",
              component: ManageAccounts
            },
            {
              path: "upgrade",
              name: "ProfileUpgrade",
              component: ProfileUpgrade
            }
          ]
        },
        {
          path: "help",
          name: "Help",
          component: Help
        },
        {
          path: "organization",
          name: "OrganizationIndex",
          component: OrganizationIndex,
          children: [
            {
              path: "profile",
              name: "OrganizationProfile",
              component: OrgProfile
            },
            {
              path: "stamps",
              name: "OrganizationStamps",
              component: OrgStamps
            },
            {
              path: "transactions",
              name: "OrganizationTransactions",
              component: OrgTransactions
            }
          ]
        },
        {
          path: "integration",
          name: "IntegrationIndex",
          component: IntegrationIndex,
          children: [
            {
              path: "switch",
              name: "Switch",
              component: Switch
            },
            {
              path: "api-callbacks",
              name: "ApiCallbacks",
              component: ApiCallbacks
            },
            {
              path: "web",
              name: "Web",
              component: Web
            }
          ]
        },
        {
          path: "verification",
          name: "VerificationIndex",
          component: VerificationIndex,
          children: [
            {
              path: "acknowledge",
              name: "VerificationAcknowledge",
              component: VerificationAcknowledge
            },
            {
              path: "log",
              name: "VerificationLog",
              component: VerificationLog
            }
          ]
        }
      ]
    },
    {
      path: "*",
      name: "PageNotFound",
      component: PageNotFound
    }
  ]
});